// @ts-strict-ignore
import type { ApiResponse } from '@empathyco/playboard-core-domain'
import type {
  ApiSemanticResponse,
  SemanticSuggestion,
  SemanticSuggestionStatus,
  StatusModel,
} from './interfaces/semantic.service'
import { ApiService } from '../services/api.service'

export class SemanticService extends ApiService {
  async checkStatus(): Promise<Array<StatusModel>> {
    const endpointUrl = '/status'
    const {
      data: {
        data: { models },
      },
    } = await this.fetch<SemanticSuggestionStatus>(endpointUrl)

    return models
  }

  async searchSingle(
    instanceId: string,
    params: { query: string; limit: number; lang: string },
  ): Promise<Array<SemanticSuggestion>> {
    const endpointUrl = `/search_single/${instanceId}`
    const requestParams = {
      q: params.query,
      k: params.limit,
      lang: params.lang,
      filter_ids: 'NOT_PARTIAL,NOT_ALL_WORDS',
      term_merge: false,
    }
    const {
      data: {
        data: { candidates, query },
      },
    } = await this.fetch<ApiResponse<ApiSemanticResponse>>(
      endpointUrl,
      requestParams,
      undefined,
      true,
    )

    return candidates.map(suggestion => ({ ...suggestion, from: query }))
  }

  async searchSemantic(
    instanceId: string,
    params: { query: string; limit: number; lang: string },
  ): Promise<Array<SemanticSuggestion>> {
    const endpointUrl = `/search_single/${instanceId}`
    const requestParams = {
      q: params.query,
      k: params.limit,
      lang: params.lang,
      filter_ids: 'NOT_PARTIAL,NOT_ALL_WORDS',
      isSPA: true,
    }
    const {
      data: {
        data: { candidates },
      },
    } = await this.fetch<ApiResponse<ApiSemanticResponse>>(
      endpointUrl,
      requestParams,
      undefined,
      true,
    )
    return candidates
  }
}
